module.exports = __webpack_public_path__ + "media/images/play-icon-a74f6c7b17dab26188935bc2277f2fa8.png";